<template>
  <v-dialog v-model="dialogbrand" persistent max-width="600">
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>{{isnewbrand?'Tambah Brand':'Edit Brand'}}</v-toolbar-title>
        <v-spacer/>
        <v-icon class="" dark @click="setdialogbrand(false)">close</v-icon>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-layout row>
          <v-col cols="12" lg="6">
            <div class="mt-5">
              <div class="">
                <ImgUpload v-on:upload="onUpload" label="Logo" :value="selectedbrand.brandlogo" v-model="selectedbrand.brandlogo"/>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="mt-5">
              <v-autocomplete
                  label="Category"
                  item-text="name"
                  item-value="id"
                  v-model="selectedbrand.productcategoryid"
                  :items="categories"
                  @change="refreshBrandGroup(selectedbrand.productcategoryid)"
              ></v-autocomplete>
            </div>
            <div class="mt-5">
              <v-autocomplete
                  label="Brand Group"
                  item-text="name"
                  item-value="id"
                  v-model="selectedbrand.brandgroupid"
                  :items="brandgroups"
              ></v-autocomplete>
            </div>
            <v-text-field  label="Nama" v-model="selectedbrand.brandname"></v-text-field>
            <v-switch v-model="statusSlider" inset label="Aktif">Aktif</v-switch>
          </v-col>
        </v-layout>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" color="red darken-1" dark @click.native="setdialogbrand(false)">Batal</v-btn>
        <v-btn elevation="0" color="primary darken-1"  @click.native="simpan">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImgUpload from '@/components/ImgUpload'

export default {
  name: 'DialogBrand',
  components: { ImgUpload },
  data: () => ({
  }),
  computed: {
    ...mapState('AdminProducts', ['dialogbrand', 'selectedbrand', 'categories', 'isnewbrand', 'brandgroups', 'brandgrouptotal']),
    statusSlider: {
      get () {
        return parseInt(this.selectedbrand.status) === 1
      },
      set (val) {
        if (val) {
          this.selectedbrand.status = 1
        } else {
          this.selectedbrand.status = 0
        }
      }
    }
  },
  methods: {
    ...mapActions('AdminProducts', ['setdialogbrand', 'editbrand', 'tambahbrand', 'getBrandGroups']),
    onUpload (img) {
      console.log(img)
      this.$store.dispatch('AdminProducts/setSelectedbrandLogo', img, { root: true })
      // this.selectedbrand.brandlogo = img
    },
    simpan () {
      if (this.isnewbrand) {
        this.tambahbrand(this.selectedbrand)
      } else {
        this.editbrand(this.selectedbrand)
      }
    },
    refreshBrandGroup (categoryId) {
      this.getBrandGroups({
        search: '',
        itemsPerPage: 100,
        page: 1,
        categoryid: categoryId
      })
    }
  }
}
</script>

<style scoped>

</style>
